export function formatPalletId(palletId: number) {
  return palletId.toString().padStart(4, "0");
}
